import {SET_SHOPIFY_MODE} from '.';

const setShopifyMode = (shopifyMode) => {
  return (dispatch) => {
      dispatch({
        type: SET_SHOPIFY_MODE,
        shopifyMode
      });
  };
};

export default setShopifyMode;
